export const DISPLAY_TYPES = {
  TILES: 'tiles',
  LARGE_TILES: 'large_tiles'
};
